import { useState } from 'react';

export interface ToggleableItems {
  toggle: (id: string) => void;
  isEnabled: (id: string) => boolean;
}

const useToggleableItems = (): ToggleableItems => {
  const [enabled, setEnabled] = useState<Set<string>>(new Set());

  const toggle = (id: string) => {
    const next = new Set(enabled);
    if (next.has(id)) {
      next.delete(id);
    } else {
      next.add(id);
    }
    setEnabled(next);
  };

  const isEnabled = (id: string) => enabled.has(id);

  return { toggle, isEnabled };
};

export default useToggleableItems;
